// src/components/admin/FloorPlanUpload.tsx
import React from 'react';
import imageCompression from 'browser-image-compression';
import { EditButton } from './EditButton';

export interface FloorPlanUploadProps {
  /** フロアプラン画像の URL。画像がない場合は undefined */
  imageUrl?: string;
  /** 画像が選択されたときのコールバック */
  onAddImage: (file: File) => void;
}

export const FloorPlanUpload: React.FC<FloorPlanUploadProps> = ({
  imageUrl,
  onAddImage,
}) => {
  // ファイルが選択されたときの処理（1MB以上なら圧縮する）
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      let processedFile = file;

      // 1MB以上のファイルは圧縮
      if (file.size > 1 * 1024 * 1024) {
        const options = {
          maxSizeMB: 1, // 1MB以下に圧縮
          maxWidthOrHeight: 1920, // 必要に応じて最大幅・高さを指定
          useWebWorker: true,
        };
        try {
          processedFile = await imageCompression(file, options);
        } catch (error) {
          console.error('画像圧縮に失敗しました:', error);
        }
      }
      onAddImage(processedFile);
    }
  };

  // 編集ボタン押下時に input をクリックさせる
  const handleEditClick = () => {
    document.getElementById('floorPlanInput')?.click();
  };

  return (
    <div className="mb-6 border-b border-gray-400">
      <div className="flex items-start my-3">
        {/* 左側のラベル */}
        <label className="font-bold w-1/6">フロアプラン</label>
        {/* 画像表示と編集ボタンのエリア（横並びに配置） */}
        <div className="flex items-center">
          {/* 画像表示エリア：固定サイズ */}
          <div
            className="border border-gray-400 rounded bg-white"
            style={{ width: '300px', minHeight: '150px', maxWidth: '300px' }}
          >
            {imageUrl ? (
              <img
                src={imageUrl}
                alt="フロアプラン"
                className="w-full h-full object-cover rounded"
                style={{ width: '300px', height: '150px', objectFit: 'cover' }}
              />
            ) : (
              <div
                className="flex justify-center items-center border-2 border-dashed rounded"
                style={{ width: '300px', minHeight: '150px' }}
              >
                <span className="text-gray-500 text-3xl">+</span>
              </div>
            )}
          </div>
          {/* 編集ボタン */}
          <div className="ml-4">
            <EditButton onClick={handleEditClick} />
          </div>
          {/* 非表示のファイル入力 */}
          <input
            id="floorPlanInput"
            type="file"
            accept="image/*"
            className="hidden"
            onChange={handleFileChange}
          />
        </div>
      </div>
    </div>
  );
};

export default FloorPlanUpload;
